<!-- 用户隐私协议 -->
<template>
    <div class="agreement">
        <div class="h3">用户协议</div>
        <div class="text">
            欢迎使用由苏州汇通典当有限公司（以下简称“本公司”“我们”）提供的服务。为了保障您的权益，请您在使用本应用及相关服务前，仔细阅读并同意本服务条款。
        </div>
        <div class="text">
            本条款适用于通过本应用提交车辆抵押典当贷款申请及相关服务的所有用户。
        </div>
        <div class="h5">
            一、服务内容
        </div>
        <div class="text">
            本应用用于为用户提供车辆抵押典当贷款的在线申请入口，包括但不限于信息提交、贷款咨询、车辆抵押评估等功能。所有贷款服务均由苏州汇通典当有限公司依法独立提供。
        </div>
        <div class="h5">
            二、用户资格
        </div>
        <div class="text">
            使用本服务的用户应满足以下条件：
        </div>
        <div class="text">
            1、年满18周岁且具有完全民事行为能力；
        </div>
        <div class="text">
            2、提供真实、准确、完整的个人及车辆信息；
        </div>
        <div class="text">
            3、对抵押车辆享有合法所有权且不存在权属争议。
        </div>
        <div class="h5">
            三、抵押车辆评估与贷款发放
        </div>
        <div class="text">
            1、用户提交车辆信息后，我们将依据车辆状况与市场行情进行抵押评估。
        </div>
        <div class="text">
            2、贷款金额将依据评估结果确定。
        </div>
        <div class="h5">
            3、贷款经审核通过后，由本公司依法发放，用户需签署线下典当合同。
        </div>
        <br>
        <div class="h5">
            四、费用及还款
        </div>
        <div class="text">
            1、本公司将向用户清晰披露各项费用、利率及还款方式，且不收取任何隐性费用。
        </div>
        <div class="text">
            2、用户应按照合同约定按时还款。
        </div>
        <div class="h5">
            3、如出现逾期，本公司将依据典当相关法律法规处理，包括但不限于计收逾期费用或依法处置抵押物。
        </div>
        <br>
        <div class="h5">
            五、用户责任
        </div>
        <div class="text">
            用户应保证：
        </div>
        <div class="text">
            1、所提交信息真实有效；
        </div>
        <div class="text">
            2、抵押车辆不存在查封、抵押、质押或其他权利负担；
        </div>
        <div class="text">
            3、妥善履行合同义务。
        </div>
        <div class="text">
            4、如因用户提供虚假信息导致本公司损失，用户须承担相关法律责任。
        </div>
        <br>
        <div class="h5">
            六、公司责任
        </div>
        <div class="text">
            我们负责：
        </div>
        <div class="text">
            1、合规提供典当贷款服务；
        </div>
        <div class="text">
            2、妥善存储用户信息并保障安全；
        </div>
        <div class="text">
            3、提供咨询与售后服务。
        </div>
        <div class="text">
            我们不对以下情况承担责任：
        </div>
        <div class="text">
            ·因不可抗力导致的服务中断或数据丢失；
        </div>
        <div class="text">
            ·用户自身原因导致的损失；
        </div>
        <div class="text">
            ·第三方提供服务引发的不可控结果。
        </div>
        <br>
        <div class="h5">
            七、争议解决
        </div>
        <div class="text">
            若用户在使用本服务过程中发生争议，可通过以下方式联系本公司解决：
        </div>
        <div class="text">
            ·电话：18913109914
        </div>
        <div class="text">
            ·地址：江苏省苏州市金阊区西环路2708号101室
        </div>
        <div class="text">
            如无法协商解决，争议将提交本公司注册地址所在地人民法院管辖。
        </div>
        <br>
        <div class="h5">
            八、条款更新
        </div>
        <div class="text">
            我们可能根据法律法规或服务调整对本条款进行修改。更新后的条款将在应用内公示，用户继续使用即视为同意。
        </div>
        <br>
        <div class="h5">
            九、联系我们
        </div>
        <div class="text">
            苏州汇通典当有限公司
        </div>
        <div class="text">
            地址：江苏省苏州市金阊区西环路2708号101室
        </div>
        <div class="text">
            电话：18913109914
        </div>
    </div>
</template>

<script>
import { ref, reactive } from 'vue'
export default {
    setup() {
        
    }
}

</script>
<style scoped>
.agreement{
    padding: 0 15px 20px;
}
.h3{
    font-size: 20px;
    margin: 10px 0;
    text-align: center;
}
.agreement .h5{
    font-size: 18px;
}
.text{
    font-size: 16px;
    text-indent: 34px;
}
</style>